import { usePaymentControllerGetAllEduOrgsQuery } from '@api/admin/adminGeneratedApi';

export const useGetEduOrgs = () => {
  const { data, isLoading } = usePaymentControllerGetAllEduOrgsQuery();

  return { data, isLoading };
};
